import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { MarkdownModule } from 'ngx-markdown';
import { QuillModule } from 'ngx-quill';
import { ToastrModule } from 'ngx-toastr';
import { AudioPlayerComponent } from 'src/app/shared/components/audio-player/audio-player.component';
import { FileUploaderComponent } from 'src/app/shared/components/file-uploader/file-uploader.component';
import { LanguageSelectorComponent } from 'src/app/shared/components/language-selector/language-selector.component';
import { MoreButtonComponent } from 'src/app/shared/components/more-button/more-button.component';
import { QuillToolbarComponent } from 'src/app/shared/components/quill-toolbar/quill-toolbar.component';
import { FilterSectionWideComponent } from 'src/app/shared/components/ui/filter-section-wide/filter-section-wide.component';
import { TableWrapperComponent } from 'src/app/shared/components/ui/table-wrapper/table-wrapper.component';
import { DropdownAnchorDirective } from 'src/app/shared/directives/dropdown-anchor.directive';
import { DropdownLinkDirective } from 'src/app/shared/directives/dropdown-link.directive';
import { AppDropdownDirective } from 'src/app/shared/directives/dropdown.directive';
import { ExcerptPipe } from 'src/app/shared/pipes/excerpt.pipe';
import { ContentChangeDialogComponent } from '../../shared/components/content-change-dialog/content-change-dialog.component';
import { MaterialModule } from '../../shared/material.module';
import { AppPopContentComponent } from '../../shared/services/app-pop-content/app-pop-content.component';
import { AppPopContentService } from '../../shared/services/app-pop-content/app-pop-content.service';
import { SharedModule } from '../../shared/shared.module';
import { ChunkControllerComponent } from './chunk/chunk-controller/chunk-controller.component';
import { ChunkDisplayerComponent } from './chunk/chunk-displayer/chunk-displayer.component';
import { ChunkImageDisplayerComponent } from './chunk/chunk-image-displayer/chunk-image-displayer.component';
import { ChunkComponent } from './chunk/chunk.component';
import { ChunkService } from './chunk/chunk.service';
import { CreateChunkComponent } from './chunk/create-chunk/create-chunk.component';
import { TagCreatorComponent } from './chunk/tag-creator/tag-creator.component';
import { ContentComponent } from './content.component';
import { ContentService } from './content.service';
import { SearcherComponent } from './searcher/searcher.component';
import { BulkActionBarComponent } from 'src/app/shared/components/ui/bulk-action-bar/bulk-action-bar.component';
import { SkeletonComponent } from 'src/app/shared/components/ui/skeleton/skeleton.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const standalones = [
  SkeletonComponent,
  ExcerptPipe,
  FileUploaderComponent,
  MoreButtonComponent,
  LanguageSelectorComponent,
  FilterSectionWideComponent,
  TableWrapperComponent,
  QuillToolbarComponent,
  AudioPlayerComponent,
  ChunkImageDisplayerComponent,
  ChunkDisplayerComponent,
  ChunkControllerComponent,
  CreateChunkComponent,
  TagCreatorComponent,
  SearcherComponent,
  BulkActionBarComponent,
];
const directives = [AppDropdownDirective, DropdownLinkDirective, DropdownAnchorDirective];

const componentsToAdd = [ChunkComponent, ContentChangeDialogComponent, AppPopContentComponent, ContentComponent];

@NgModule({
  declarations: [...componentsToAdd, ...directives],
  exports: [...componentsToAdd],
  providers: [ChunkService, ContentService, AppPopContentService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    // CommonModule,
    ...standalones,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgClickOutsideDirective,
    SharedModule,
    ToastrModule.forRoot(),
    QuillModule,
    MarkdownModule,
    TranslateModule,
  ],
})
export class ContentModule {}
